import React, { useState } from 'react';
import { CalendarIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { Modal } from '../ui/Modal';
import { DemoRequestForm } from '../forms/DemoRequestForm';
import { useTranslation } from '../../lib/i18n';
export function DemoRequest() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    lang
  } = useTranslation();
  return <>
      <section className="py-20 bg-dark-surface" data-id="element-185">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-186">
          <div className="w-16 h-16 bg-brand-yellow rounded-industrial flex items-center justify-center mx-auto mb-6" data-id="element-187">
            <CalendarIcon className="w-8 h-8 text-dark-bg" data-id="element-188" />
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4" data-id="element-189">
            {lang === 'en' ? <>
                See it <span className="text-brand-yellow" data-id="element-190">in action</span>
              </> : <>
                Pogledajte <span className="text-brand-yellow" data-id="element-191">u akciji</span>
              </>}
          </h2>
          <p className="text-xl text-gray-400 mb-8 max-w-2xl mx-auto" data-id="element-192">
            {lang === 'en' ? 'Schedule a live demonstration at your location. Experience the power and reliability of D-TECH equipment first-hand.' : 'Zakažite demonstraciju uživo na vašoj lokaciji. Iskusite snagu i pouzdanost D-TECH opreme iz prve ruke.'}
          </p>
          <Button variant="primary" size="lg" onClick={() => setIsModalOpen(true)} data-id="element-193">
            {lang === 'en' ? 'Request demonstration' : 'Zatražite demonstraciju'}
          </Button>
          <p className="text-sm text-gray-400 mt-4" data-id="element-194">
            {lang === 'en' ? 'Demo requests must be submitted at least 5 days in advance' : 'Zahtevi za demonstraciju moraju biti podneseni najmanje 5 dana unapred'}
          </p>
        </div>
      </section>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title={lang === 'en' ? 'Request demonstration' : 'Zatražite demonstraciju'} maxWidth="lg" data-id="element-195">
        <DemoRequestForm onSuccess={() => setIsModalOpen(false)} data-id="element-196" />
      </Modal>
    </>;
}